import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ChainSelect } from '../ChainSelect';
import { CommonField } from './CommonField';

import styles from './index.module.scss';

export const ChainUser = () => {
  const { control, setValue } = useFormContext();

  return (
    <div>
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={styles.label}>Chain</div>
        </div>
        <Controller
          control={control}
          name="data.chain_id"
          render={({ field }) => (
            <ChainSelect
              value={field.value}
              onChange={val => {
                field.onChange(val.id);
                setValue('data.chain_name', val.name);
              }}
            />
          )}
          rules={{
            required: true,
          }}
        />
      </div>
      <CommonField hideLink />
    </div>
  );
};
